import { createSlice } from '@reduxjs/toolkit';

const initialState: number[] = [];

export const cancelledOrdersSlice = createSlice({
  name: 'cancelledOrders',
  initialState,
  reducers: {
    setCancelledOrders: (state, action: { payload: number }) => [...state, action.payload],
  },
});

export const { setCancelledOrders } = cancelledOrdersSlice.actions;

export default cancelledOrdersSlice.reducer;
